import { trackFacebookConversion } from './facebook';
import { trackGoogleConversion } from './google';
import { trackTaboolaConversion } from './taboola';
import request from './request';

const monthNames = [
  `January`, `February`, `March`,
  `April`, `May`, `June`, `July`,
  `August`, `September`, `October`,
  `November`, `December`,
];

const Days = [
  `Sunday`, `Monday`, `Tuesday`, `Wednesday`,
  `Thursday`, `Friday`, `Saturday`,
];

export * from './signs';
export * from './qualities';

const env = process.env.API_ENV || `development`;

const urls = {
  production: {
    LUCINA_URL: `https://api-lucina.com`,
    API_BASE: `https://api.starlies.com`,
  },
  staging: {
    LUCINA_URL: `https://internal.minerva.dev/staging/lucina`,
    API_BASE: `https://internal.minerva.dev/staging/starlies-api`,
  },
  development: {
    LUCINA_URL: `http://localhost:8080`,
    API_BASE: `http://localhost:8000`,
  },
};


export const { API_BASE, LUCINA_URL } = urls[env];

export const LIVE_SITE = Boolean(process.env.API_ENV && process.env.NODE_ENV);

export const BANNER_AD = [[970, 90], [728, 90], [320, 100]];
export const MOBILE_BANNER_AD = [[320, 50]];
export const RECT_ADS = [[336, 280], [300, 250]];
export const SIDE_ADS = [[300, 600], [160, 600]];

export const dateToString = (date) => {
  return `${Days[date.getDay()]}, ${monthNames[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
};

export const getToday = () => {
  return new Date();
};

export const getYesterday = () => {
  return ((d) => new Date(d.setDate(d.getDate() - 1)))(new Date());
};

export const getTomorrow = () => {
  return ((d) => new Date(d.setDate(d.getDate() + 1)))(new Date());
};

export const convertDate = (date) =>
  (`0${date.getMonth() + 1}`).slice(-2) + (`0${date.getDate()}`).slice(-2) + date.getFullYear();

export const convertApiDate = (dateString) =>
  `${dateString.slice(4, 8)}-${dateString.slice(0, 2)}-${dateString.slice(2, 4)}`;

export const extraParams = (query) => {
  const { signup_box: signupBox } = query;
  const params = `?signup_box=${signupBox}`;

  return signupBox ? params : ``;
};

export const piwikMethod = (type, data) => {
  if (window && window._paq) { // eslint-disable-line
    window._paq.push([type, ...data]); // eslint-disable-line
  } else {
    console.log([type, ...data]); // eslint-disable-line
  }
};

/* eslint-disable */
export const event = (data) => {
  if (window) {
    if (window._paq) {
      window._paq.push([`trackEvent`, ...data]);
    } else {
      console.log([`trackEvent`, ...data]);
    }
  }
};

export const trackGoogleAnalyticsPageView = () => {
  if (window.gtag) {
    window.gtag(`config`, `UA-98455161-1`, {
      page_title: document.title,
      page_path: `${window.location.pathname}${window.location.search}`,
      page_location: window.location.href,
    });
  }
}

export { trackFacebookConversion, request, trackGoogleConversion, trackTaboolaConversion };
